import { UsersService } from '@shared/services/users/users.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map, filter, timeout, of } from 'rxjs';
import { ErrorService } from 'app/error-handler/services/error.service';
import { NotAuthorizedError } from 'app/error-handler/custom-errors/not-authorized-error';


@Injectable()
export class UserGuard  {
    constructor(
      private usersService: UsersService,
      private errorService: ErrorService
      )
    {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        const userSlug = route.paramMap.get('userSlug');
        return this.usersService.onUserChange
        .pipe(
          filter(u => u !== null),
          map(user => {
            const isOwner = userSlug === user?.slug; // solo utente proprietario del profilo
            if (!isOwner) {
              this.errorService.handleError(new NotAuthorizedError(state.url));
              return false;
            }
            return true;
          }),
          timeout({
            each: 2000,
            with: () => {
              this.errorService.handleError(new NotAuthorizedError(state.url));
              return of(false);
            },
          })
        );
    }
}
